<div class="contains-button">

  <!-- {{'hien_thi' | translate}} tiêu đề {{'mo_rong' | translate}} -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn {{'hien_thi' | translate}} cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

        </div>
      </li>
      <!-- Chọn loại dữ liệu -->
      <li nz-submenu nzTitle="Chọn loại dữ liệu" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <nz-select [(ngModel)]="staticdata.dataType" nzPlaceHolder="Chọn loại dữ liệu" allowClear
          (ngModelChange)="updateObject();">
          <nz-option [nzValue]="'city'" nzLabel="Tỉnh/Thành phố"></nz-option>
          <nz-option [nzValue]="'province'" nzLabel="Quận/Huyện"></nz-option>
          <nz-option [nzValue]="'district'" nzLabel="Xã/Thị trấn"></nz-option>
        </nz-select>
      </li>
      <!-- Cấu hình Định dạng tên nút -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="container-font">
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="
                      class['select-address__content']['font-family']
                    " (ngModelChange)="updateClass()" [(value)]="class['select-address__content']['font-family']">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                    font.name
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field style="width: 100%">
                <mat-label>Kích thước</mat-label>
                <input matInput type="number" [ngModel]="
                      class['select-address__content']['font-size'] | vhnumber
                    " (ngModelChange)="
                      class['select-address__content']['font-size'] =
                        $event + 'px'
                    " />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">Kiểu chữ</p>
            <div class="field-row">
              <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                    class['select-address__content']['font-weight'] == 'bold'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['select-address__content']['font-weight'] =
                      class['select-address__content']['font-weight'] == 'bold'
                        ? '500'
                        : 'bold';
                    updateClass()
                  ">
                <span style="font-weight: 600">B</span>
              </button>
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                    class['select-address__content']['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['select-address__content']['font-style'] =
                      class['select-address__content']['font-style'] == 'normal'
                        ? 'italic'
                        : 'normal';
                    updateClass()
                  ">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                    class['select-address__content']['text-decoration'] ==
                    'underline'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['select-address__content']['text-decoration'] =
                      class['select-address__content']['text-decoration'] ==
                      'none'
                        ? 'underline'
                        : 'none';
                    updateClass()
                  ">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                    class['select-address__content']['text-transform'] ==
                    'uppercase'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['select-address__content']['text-transform'] =
                      class['select-address__content']['text-transform'] ==
                      'none'
                        ? 'uppercase'
                        : 'none';
                    updateClass()
                  ">
                <span>AB</span>
              </button>
              <div>
                <input id="color" type="button" [cpOKButton]="true" [(colorPicker)]="class['select-address__content']['color']"
                  [style.background]="class['select-address__content']['color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
              </div>
            </div>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">Giãn cách chữ</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['select-address__content']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['select-address__content']['letter-spacing'] =
                      $event + 'px'
                  ">
              </nz-input-number>
            </div>

            <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                      class['select-address__content']['letter-spacing'] | vhnumber
                    " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                      class['select-address__content']['letter-spacing'] =
                        $event + 'px'
                    "></nz-slider>
          </div>

          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">Khoảng cách giữa nút và danh sách</span>
              <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['select-address__options-list']['top'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['select-address__options-list']['top'] =
                      $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="
                      class['select-address__options-list']['top'] | vhnumber
                    " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                      class['select-address__options-list']['top'] =
                        $event + 'px'
                    ">
            </nz-slider>
          </div>

          <div class="color-pick">
            <span class="title w-50">Màu nền </span>
            <input class="input-color w-50" type="button"
              [cpOKButton]="true" [(colorPicker)]="class['select-address__button']['background-color']"
              [style.background]="class['select-address__button']['background-color']"
              (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
          </div>


        </div>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['select-address__button']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút {{'mo_rong' | translate}} -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-symbol-config [device]="device" [class]="class" [config]="config"
          [symbolClass]="class['select-address__button']" [fontSizeIconClass]="class['select-address__icon']"
          [symbolConfig]="config['icon']" [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình thanh tìm kiếm -->
      <li nz-submenu nzTitle="Cấu hình thanh tìm kiếm">
        <ul>
          <li nz-submenu class="pl-2" nzTitle="Thông số cơ bản" [(nzOpen)]="openMap.menu7"
            (nzOpenChange)="openHandler('menu7')">
            <div class="container-font">
              <div class="config-text" style="width: 100%">
                <mat-form-field style="width: 100%">
                  <mat-label>Nội dung placeholder</mat-label>
                  <textarea matInput
                    [ngModel]="staticdata['input_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_placeholder' : objectChoosing.component" 
                    (ngModelChange)="staticdata['input_placeholder_' + functionService.selectedLanguageCode] = $event"  
                    (blur)="updateStaticData()"></textarea>
                </mat-form-field>
              </div>
              <div class="config-font-size">
                <div class="field-row-font" style="width: 65%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Font</mat-label>
                    <mat-select [(ngModel)]="
                          class['select-address__search-input']['font-family']
                        " (ngModelChange)="updateClass()"
                      [(value)]="class['select-address__search-input']['font-family']">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                        font.name
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Kích thước</mat-label>
                    <input matInput type="number" [ngModel]="
                          class['select-address__search-input']['font-size'] | vhnumber
                        " (ngModelChange)="
                          class['select-address__search-input']['font-size'] =
                            $event + 'px'
                        " />
                  </mat-form-field>
                </div>
              </div>
              <div class="config-font">
                <p class="title-font">Kiểu chữ</p>
                <div class="field-row">
                  <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                        class['select-address__search-input']['font-weight'] == 'bold'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__search-input']['font-weight'] =
                          class['select-address__search-input']['font-weight'] == 'bold'
                            ? '500'
                            : 'bold';
                        updateClass()
                      ">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['select-address__search-input']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__search-input']['font-style'] =
                          class['select-address__search-input']['font-style'] == 'normal'
                            ? 'italic'
                            : 'normal';
                        updateClass()
                      ">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['select-address__search-input']['text-decoration'] ==
                        'underline'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__search-input']['text-decoration'] =
                          class['select-address__search-input']['text-decoration'] ==
                          'none'
                            ? 'underline'
                            : 'none';
                        updateClass()
                      ">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                        class['select-address__search-input']['text-transform'] ==
                        'uppercase'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__search-input']['text-transform'] =
                          class['select-address__search-input']['text-transform'] ==
                          'none'
                            ? 'uppercase'
                            : 'none';
                        updateClass()
                      ">
                    <span>AB</span>
                  </button>
                  <div>
                    <input id="color" type="button" [cpOKButton]="true" [(colorPicker)]="class['select-address__search-input']['color']"
                      [style.background]="class['select-address__search-input']['color']"
                      (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                  </div>
                </div>
              </div>
              <div class="font-adjusting">
                <div class="row-spacing">
                  <span class="title">Giãn cách chữ</span>
                  <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                        class['select-address__search-input']['letter-spacing'] | vhnumber
                      " (nzBlur)="updateClass()" (ngModelChange)="
                        class['select-address__search-input']['letter-spacing'] =
                          $event + 'px'
                      "></nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                          class['select-address__search-input']['letter-spacing'] | vhnumber
                        " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                          class['select-address__search-input']['letter-spacing'] =
                            $event + 'px'
                        ">
                </nz-slider>
              </div>
              <div class="color-pick">
                <span class="title w-50">Màu nền</span>
                <input class="input-color w-50" type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['select-address__search']['background-color']"
                  [style.background]="class['select-address__search']['background-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
              </div>
            </div>
          </li>
          <li nz-submenu class="pl-2" nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu8"
            (nzOpenChange)="openHandler('menu8')">
            <app-symbol-config [device]="device" [class]="class" [config]="config"
              [symbolClass]="class['select-address__search']" [fontSizeIconClass]="class['select-address__search-icon']"
              [symbolConfig]="config['icon_search']" [objectChoosing]="objectChoosing">
            </app-symbol-config>
          </li>
        </ul>
      </li>
      <!-- Cấu hình tdanh sách đối tượng -->
      <li nz-submenu nzTitle="Cấu hình danh sách đối tượng">
        <ul>
          <li nz-submenu class="pl-2" nzTitle="Thông số cơ bản" [(nzOpen)]="openMap.menu9"
            (nzOpenChange)="openHandler('menu9')">
            <div class="container-font">
              <div class="config-font-size">
                <div class="field-row-font" style="width: 65%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Font</mat-label>
                    <mat-select [(ngModel)]="
                          class['select-address__item']['font-family']
                        " (ngModelChange)="updateClass()" [(value)]="class['select-address__item']['font-family']">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                        font.name
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Kích thước</mat-label>
                    <input matInput type="number" [ngModel]="
                          class['select-address__item']['font-size'] | vhnumber
                        " (ngModelChange)="
                          class['select-address__item']['font-size'] =
                            $event + 'px'
                        " />
                  </mat-form-field>
                </div>
              </div>
              <div class="config-font">
                <p class="title-font">Kiểu chữ</p>
                <div class="field-row">
                  <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                        class['select-address__item']['font-weight'] == 'bold'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item']['font-weight'] =
                          class['select-address__item']['font-weight'] == 'bold'
                            ? '500'
                            : 'bold';
                        updateClass()
                      ">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['select-address__item']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item']['font-style'] =
                          class['select-address__item']['font-style'] == 'normal'
                            ? 'italic'
                            : 'normal';
                        updateClass()
                      ">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['select-address__item']['text-decoration'] ==
                        'underline'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item']['text-decoration'] =
                          class['select-address__item']['text-decoration'] ==
                          'none'
                            ? 'underline'
                            : 'none';
                        updateClass()
                      ">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                        class['select-address__item']['text-transform'] ==
                        'uppercase'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item']['text-transform'] =
                          class['select-address__item']['text-transform'] ==
                          'none'
                            ? 'uppercase'
                            : 'none';
                        updateClass()
                      ">
                    <span>AB</span>
                  </button>
                  <div>
                    <input id="color" type="button" [cpOKButton]="true" [(colorPicker)]="class['select-address__item']['color']"
                      [style.background]="class['select-address__item']['color']" (colorPickerClose)="updateObject()"
                      [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                  </div>
                </div>
              </div>
              <div class="font-adjusting">
                <div class="row-spacing">
                  <span class="title">Giãn cách chữ</span>
                  <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                        class['select-address__item']['letter-spacing'] | vhnumber
                      " (nzBlur)="updateClass()" (ngModelChange)="
                        class['select-address__item']['letter-spacing'] =
                          $event + 'px'
                      "></nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                          class['select-address__item']['letter-spacing'] | vhnumber
                        " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                          class['select-address__item']['letter-spacing'] =
                            $event + 'px'
                        ">
                </nz-slider>
              </div>

              <div class="color-pick">
                <span class="title w-50">Màu nền</span>
                <input class="input-color w-50" type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['select-address__item']['background-color']"
                  [style.background]="class['select-address__item']['background-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
              </div>
            </div>
          </li>
          <li nz-submenu class="pl-2" nzTitle="Đối tượng khi được chọn" [(nzOpen)]="openMap.menu10"
            (nzOpenChange)="openHandler('menu10')">
            <div class="container-font">
              <div class="config-font-size">
                <div class="field-row-font" style="width: 65%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Font</mat-label>
                    <mat-select [(ngModel)]="
                          class['select-address__item-active']['font-family']
                        " (ngModelChange)="updateClass()"
                      [(value)]="class['select-address__item-active']['font-family']">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                        font.name
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Kích thước</mat-label>
                    <input matInput type="number" [ngModel]="
                          class['select-address__item-active']['font-size'] | vhnumber
                        " (ngModelChange)="
                          class['select-address__item-active']['font-size'] =
                            $event + 'px'
                        " />
                  </mat-form-field>
                </div>
              </div>
              <div class="config-font">
                <p class="title-font">Kiểu chữ</p>
                <div class="field-row">
                  <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                        class['select-address__item-active']['font-weight'] == 'bold'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item-active']['font-weight'] =
                          class['select-address__item-active']['font-weight'] == 'bold'
                            ? '500'
                            : 'bold';
                        updateClass()
                      ">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['select-address__item-active']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item-active']['font-style'] =
                          class['select-address__item-active']['font-style'] == 'normal'
                            ? 'italic'
                            : 'normal';
                        updateClass()
                      ">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['select-address__item-active']['text-decoration'] ==
                        'underline'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item-active']['text-decoration'] =
                          class['select-address__item-active']['text-decoration'] ==
                          'none'
                            ? 'underline'
                            : 'none';
                        updateClass()
                      ">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                        class['select-address__item-active']['text-transform'] ==
                        'uppercase'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class['select-address__item-active']['text-transform'] =
                          class['select-address__item-active']['text-transform'] ==
                          'none'
                            ? 'uppercase'
                            : 'none';
                        updateClass()
                      ">
                    <span>AB</span>
                  </button>
                  <div>
                    <input id="color" type="button" [cpOKButton]="true" [(colorPicker)]="class['select-address__item-active']['color']"
                      [style.background]="class['select-address__item-active']['color']"
                      (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                  </div>
                </div>
              </div>
              <div class="font-adjusting">
                <div class="row-spacing">
                  <span class="title">Giãn cách chữ</span>
                  <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                        class['select-address__item-active']['letter-spacing'] | vhnumber
                      " (nzBlur)="updateClass()" (ngModelChange)="
                        class['select-address__item-active']['letter-spacing'] =
                          $event + 'px'
                      ">
                  </nz-input-number>
                </div>

                <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                          class['select-address__item-active']['letter-spacing'] | vhnumber
                        " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                          class['select-address__item-active']['letter-spacing'] =
                            $event + 'px'
                        ">
                </nz-slider>
              </div>

              <div class="color-pick">
                <span class="title w-50">Màu nền </span>
                <input class="input-color w-50" type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['select-address__item-active']['background-color']"
                  [style.background]="class['select-address__item-active']['background-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
              </div>
            </div>
          </li>
        </ul>
      </li>

    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['select-address__button']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>

    </div>
    <!-- Cấu hình chi tiết {{'hieu_ung' | translate}} -->
  </div>
</div>